<template>
    <div class="chat-page chat-admin">
        <div class="chat-aside" v-if="conversation">
            <div class="filter-search">
                <form action="" @submit.prevent="" autocomplete="off">
                    <button type="submit">
                        <svg-icon icon="search-icon-app" />
                    </button>

                    <button v-if="search" class="filter-remove" type="button" @click.prevent="search = ''">
                        <span class="material-icons-round">close</span>
                    </button>

                    <input v-model="search" name="search" type="text" :placeholder="__('Find a patient')" />
                </form>
            </div>

            <div 
                v-for="conversationItem in conversationsFiltered"
                :key="conversationItem.id"
                :class="['aside-patient', { active: conversation.id === conversationItem.id }]"
                @click="setConversation(conversationItem)"
            >
                <UserAvatar :user-info="conversationItem" size="xs" />
                <div>
                    <span class="name">{{ conversationItem | fullname }}</span>
                    <span class="time">{{ moment(conversationItem.last_contact).fromNow() }}</span>
                </div>
            </div>
        </div>

        <div>
            <div v-if="conversation" class="sc-chat-window opened">
                <ChatHeader :conversation="conversation" :conversations="[]" @changeConversation="setConversation" />

                <div class="sc-message-list">
                    <ChatMessage
                        v-for="(message, i) in messagesArray"
                        :key="i"
                        :last="isLast(i)"
                        :message="message"
                        :coachId="coach.user.id"
                    />
                </div>
            </div>

            <div v-else-if="!conversation && !loading" class="no-data">
                <figure>
                    <svg-icon icon="icon-no-data"></svg-icon>
                </figure>
                <p>{{ __("No records") }}</p>
            </div>

            <div v-if="loading" class="loader-wrapper">
                <img src="/imgs/vitadio-loader.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import ChatMessage from '@app/chat/components/chat/ChatMessage.vue'
import ChatHeader from '@app/chat/components/chat/ChatHeader.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        ChatHeader,
        ChatMessage
    },
    props: {
        coach: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            conversations: [],
            conversationsFiltered: [],
            conversation: null,
            messagesCollection: {},
            loading: true,
            search: '',
            patient: {
                user_id: null,
                user: null
            }
        }
    },
    watch: {
        async 'messages.length'() {
            await this.$nextTick()

            this.scrollDown()
        },
        '$parent.tab'(tab) {
            if (tab === 'chat') {
                this.fetch()
            }
        },
        search() {
            if (this.search != '' && this.search) {
                this.conversationsFiltered = this.conversations.filter((conversation) => {
                    const fullName = this.removeDiacritics(`${conversation.name} ${conversation.surname}`).toLowerCase();
                    const reverseFullName = this.removeDiacritics(`${conversation.surname} ${conversation.name}`).toLowerCase();
                    const searchLower = this.removeDiacritics(this.search).toLowerCase();
                    if(fullName.includes(searchLower) || 
                        reverseFullName.includes(searchLower) || 
                        this.removeDiacritics(conversation.name).toLowerCase().includes(searchLower) || 
                        this.removeDiacritics(conversation.surname).toLowerCase().includes(searchLower)) {
                            return conversation
                        }
                })
            } else {
                this.conversationsFiltered = this.conversations
            }
        }
    },
    computed: {
        ...mapGetters({
            channels: 'chat/channels',
            messages: 'chat/messages',
        }),
        messagesArray() {
            const messages = this.messages.map(message => {
                if(this.patient.user_id == message.from) {
                    message.user = this.patient.user 
                } else {
                    this.channels.forEach(channel => {
                        if(channel.coach.user.id == message.from) {
                            message.user = channel.coach.user
                        }
                    });
                }

                return message
            })

            return _.orderBy(messages, 'created_at')
        }
    },
    methods: {
        ...mapActions({
            fetchAvailableChannels: 'chat/fetchAvailableChannels',
            fetchMessagesChannel: 'chat/fetchMessagesChannel'
        }),
        async fetch() {
            this.conversationsFiltered = this.conversations = await axios.get(`/coaches/${this.coach.id}/channels`).thenData()
                .catch(function (error) {
                    console.log(error.response);
                })

            if (this.conversations.length > 0) {
                this.setConversation(_.first(this.conversations))
            } else {
                this.loading = false
            }
        },
        async setConversation(conversation) {
            this.loading = true
            this.conversation = conversation

            this.patient = {
                user_id: conversation.id,
                user: conversation
            }

            await this.fetchAvailableChannels(this.conversation.patient_id)

            await this.channels.forEach(channel => {
                this.fetchMessagesChannel(channel.channel_id)
            });

            this.loading = false
        },
        scrollDown() {
            const $list = $(this.$el).find('.sc-message-list')

            if ($list.length > 0) {
                $list.animate({ scrollTop: $list[0].scrollHeight }, 0)
            }
        },
        isLast(i) {
            return i === this.messages.length - 1
        },
        removeDiacritics(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
    }
}
</script>
